import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export class ArrayUtils {

  private static UTILS_EXTRACT_ARRAY_LOCATOR_CONDITION_REGEX = '\\[(.+)\\]';
  private static UTILS_EXTRACT_DOUBLE_ARRAY_LOCATOR_CONDITION_REGEX = '\\[\\[(.+)\\]\\]';

  /**
   * Merge 2 arrays with reserved places using the reservation Term
   * if no reservation places found items will add to the end of the source array
   *
   * @param {Array<any>} source
   * @param {Array<any>} arrayToMerge
   * @param {string | number | null | undefined} reservationTerm
   * @return {Array<any>}
   */
  public static reservationMerge(source: Array<any>, arrayToMerge: Array<any>, reservationTerm: string | number | null | undefined = undefined): Array<any> {
    let index;
    while (arrayToMerge.length > 0 && (index = source.findIndex(item => item === reservationTerm)) > -1) {
      source[index] = arrayToMerge.shift();
    }
    source.push.apply(source, arrayToMerge);
    return source;
  }

  public static getArrayRelatedPath(path: string, arrayRepresentation: string = '[*]') {
    return path.split(arrayRepresentation).map(field => field.startsWith('.') ? field.slice(1) : field).filter(field => !!field);
  }

  public static walk(arrayOfObjects: any, path: string) {
    const splitPath = path.split('.');
    for (const i in splitPath) {
      if (splitPath.hasOwnProperty(i)) {
        const p = splitPath[i];
        if (p.indexOf('[[') === -1) {
          const _extractArrayName = new RegExp(ArrayUtils.UTILS_EXTRACT_ARRAY_LOCATOR_CONDITION_REGEX);
          const _arrayKeyName = _extractArrayName.exec(p);
          arrayOfObjects = _arrayKeyName[1] ? arrayOfObjects.map(obj => obj[_arrayKeyName[1]]) : arrayOfObjects;

        } else {
          const _extractArrayName = new RegExp(ArrayUtils.UTILS_EXTRACT_DOUBLE_ARRAY_LOCATOR_CONDITION_REGEX);
          const _arrayKeyName = _extractArrayName.exec(p);
          arrayOfObjects = _arrayKeyName[1] ? arrayOfObjects.map(arr => arr.map(obj => obj[_arrayKeyName[1]])) : arrayOfObjects;
        }
      }
    }
    return arrayOfObjects;
  }

  public static filterEmpty<T>(): OperatorFunction<T | null | undefined, T> {
    return filter<T>(value => value !== undefined && value !== null);
  }

}
